import { AssetInformation, BaseModalProps, Modal } from 'components/core-v2'

import { useGetByTenantAssetAndAssetIdQuery } from '../../../../../api'
import { TENANT } from '../../../../../const'
import { Loading } from './Loading'

interface Props extends BaseModalProps {
  assetId: string
}
const Body = ({ assetId, onClose }: Omit<Props, 'isOpen'>) => {
  const { data, isLoading } = useGetByTenantAssetAndAssetIdQuery({ tenant: TENANT, assetId })
  if (isLoading) return <Loading onClose={onClose} />
  return (
    <>
      <Modal.Header id="assets-modal-label" onClose={onClose}>
        <h2>{data.name}</h2>
      </Modal.Header>
      <Modal.Body className="mb-4">
        <AssetInformation asset={data} />
      </Modal.Body>
    </>
  )
}

export const AssetInformationModal = ({ assetId, isOpen, onClose }: Props) => (
  <Modal.Wrapper aria-labelledby="assets-modal-label" isOpen={isOpen} width="lg" onClose={onClose}>
    <Body assetId={assetId} onClose={onClose} />
  </Modal.Wrapper>
)
